"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.methods = void 0;
var fp = require("fp-ts");
var monocle = require("monocle-ts");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var uploadedFilesReducer = require("./uploadedFiles");
var initialState = {
    modalState: {
        isOpen: false,
        description: (0, translation_1.getLocalization)('fileUploadModal/description/generic'),
        showUploadStatusBar: false
    },
    uploadSettings: {
        unzip: false,
        replace: true,
        hasDuplicates: false
    },
    currentUploadStatus: {
        status: 'STANDBY',
        uploadSessionStatus: 'STANDBY',
        hasTooLargeFile: false,
        totalFiles: 0,
        speed: 0,
        startTime: 0,
        remaining: 0,
        uploadPercentage: 0,
        loadedSize: 0,
        totalSize: 0,
        session: undefined,
        allDone: false,
        allFailed: false
    },
    files: [],
    uploadedFiles: uploadedFilesReducer.initialState
};
var getInitialStateWithDescription = function (description) {
    var state = __assign({}, initialState);
    state.modalState.description = description;
    return state;
};
var modalStateLens = monocle.Lens.fromProp('modalState');
var uploadSettingsLens = monocle.Lens.fromProp('uploadSettings');
var currentUploadStatusLens = monocle.Lens.fromProp('currentUploadStatus');
var filesLens = monocle.Lens.fromProp('files');
var uploadedFilesLens = monocle.Lens.fromProp('uploadedFiles');
var baseUrlLens = monocle.Lens.fromProp('baseUrl');
// REDUCERS
exports.methods = {};
exports.methods['/SET_FILEUPLOAD_FILES'] = function (state, action) {
    if (state.modalState.isOpen) {
        return fp.function.compose(baseUrlLens.set(action.payload.baseUrl), filesLens.set(action.payload.files), currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { totalSize: action.payload.files.reduce(function (r, v) { return r + v.size; }, 0), totalFiles: action.payload.files.length })))(state);
    }
    return fp.function.compose(modalStateLens.set(__assign(__assign({}, state.modalState), { isOpen: true })), baseUrlLens.set(action.payload.baseUrl), filesLens.set(action.payload.files), currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { totalSize: action.payload.files.reduce(function (r, v) { return r + v.size; }, 0), totalFiles: action.payload.files.length })))(state);
};
exports.methods['/SET_FILEUPLOAD_MODAL_DESCRIPTION'] = function (state, action) {
    return modalStateLens.set(__assign(__assign({}, state.modalState), { description: action.payload }))(state);
};
exports.methods['/TOGGLE_FILEUPLOAD_MODAL_STATUS'] = function (state, action) {
    return fp.function.compose(modalStateLens.set(__assign(__assign({}, state.modalState), { isOpen: !state.modalState.isOpen })), currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { fileId: action.payload })))(state);
};
exports.methods['/TOGGLE_UNZIP'] = function (state, action) {
    return uploadSettingsLens.set(__assign(__assign({}, state.uploadSettings), { unzip: action.payload }))(state);
};
exports.methods['/TOGGLE_REPLACE'] = function (state, action) {
    return uploadSettingsLens.set(__assign(__assign({}, state.uploadSettings), { replace: action.payload }))(state);
};
exports.methods['/CHECK_DUPLICATE_FILES_SUCCESS'] = function (state, action) {
    return uploadSettingsLens.set(__assign(__assign({}, state.uploadSettings), { hasDuplicates: action.data }))(state);
};
exports.methods['/CHECK_DUPLICATE_FILES_FAILURE'] = function (state, action) {
    return uploadSettingsLens.set(__assign(__assign({}, state.uploadSettings), { hasDuplicates: false }))(state);
};
exports.methods['/UPLOAD_SESSION_CREATED'] = function (state, action) {
    return currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { session: action.payload.session, uploadSessionStatus: 'CREATED', status: 'UPLOADING' }))(state);
};
exports.methods['/UPLOAD_SESSION_FAILED'] = function (state) {
    return currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { uploadSessionStatus: 'FAILED' }))(state);
};
exports.methods['/FILEUPLOAD_REQUEST'] = function (state, action) {
    return fp.function.compose(modalStateLens.set(__assign(__assign({}, state.modalState), { showUploadStatusBar: action.payload.showUploadStatusBar })), currentUploadStatusLens.set(__assign(__assign({}, state.currentUploadStatus), { uploadSessionStatus: state.currentUploadStatus.session
            ? 'STANDBY'
            : 'CREATING', startTime: new Date().getTime(), projectId: action.payload.parent.project, folderId: action.payload.parent.id, folderUUID: action.payload.parent.uuid })))(state);
};
exports.methods['/FILEUPLOAD_DONE'] = function (state, action) {
    var _a;
    return getInitialStateWithDescription((_a = state.modalState.description) !== null && _a !== void 0 ? _a : (0, translation_1.getLocalization)('fileUploadModal/description/generic'));
};
exports.methods['/FILEUPLOAD_CANCEL'] = function (state, action) {
    var _a;
    return getInitialStateWithDescription((_a = state.modalState.description) !== null && _a !== void 0 ? _a : (0, translation_1.getLocalization)('fileUploadModal/description/generic'));
};
exports.methods['/FILEUPLOAD_FILE_CANCEL'] = function (state, action) {
    var _a;
    return getInitialStateWithDescription((_a = state.modalState.description) !== null && _a !== void 0 ? _a : (0, translation_1.getLocalization)('fileUploadModal/description/generic'));
};
exports.methods['/FILEUPLOAD_FILE_UPDATE'] = function (state, action, suffix) {
    var uploaded = uploadedFilesReducer.uploadedFiles(state.uploadedFiles, action, suffix);
    var percent = Object.entries(uploaded).reduce(function (r, _a) {
        var v = _a[1];
        return r + v.percent;
    }, 0);
    var uploadPercentage = Math.floor(percent / state.currentUploadStatus.totalFiles);
    var loadedSize = Object.entries(uploaded).reduce(function (r, _a) {
        var v = _a[1];
        return r + v.loadedSize;
    }, 0);
    var elapsed = (new Date().getTime() - state.currentUploadStatus.startTime) / 1000;
    var uploadSpeed = loadedSize / elapsed;
    var remaining = (state.currentUploadStatus.totalSize - loadedSize) / uploadSpeed;
    return fp.function.compose(monocle.Lens.fromProp('uploadedFiles').set(uploaded), monocle.Lens.fromPath([
        'currentUploadStatus',
        'remaining'
    ]).set(remaining), monocle.Lens.fromPath([
        'currentUploadStatus',
        'speed'
    ]).set(uploadSpeed), monocle.Lens.fromPath([
        'currentUploadStatus',
        'uploadPercentage'
    ]).set(uploadPercentage), monocle.Lens.fromPath([
        'currentUploadStatus',
        'loadedSize'
    ]).set(loadedSize))(state);
};
function handleFile(state, action, suffix) {
    var uploaded = uploadedFilesReducer.uploadedFiles(state.uploadedFiles, action, suffix);
    var items = Object.values(uploaded);
    var status = items.reduce(function (r, v) {
        r.percent = r.percent + v.percent;
        r.loadedSize = r.loadedSize + v.loadedSize;
        return r;
    }, { percent: 0, loadedSize: 0 });
    var allDone = items.findIndex(function (v) { return v.status !== 'FAILED' && v.status !== 'UPLOADED'; }) ===
        -1;
    var allFailed = items.findIndex(function (v) { return v.status !== 'FAILED'; }) === -1;
    var uploadPercentage = Math.floor(status.percent / state.currentUploadStatus.totalFiles);
    return fp.function.compose(monocle.Lens.fromPath([
        'currentUploadStatus',
        'status'
    ]).set(allDone ? 'UPLOADED' : 'UPLOADING'), monocle.Lens.fromProp('uploadedFiles').set(uploaded), monocle.Lens.fromPath([
        'currentUploadStatus',
        'uploadPercentage'
    ]).set(uploadPercentage), monocle.Lens.fromPath([
        'currentUploadStatus',
        'allDone'
    ]).set(allDone), monocle.Lens.fromPath([
        'currentUploadStatus',
        'allFailed'
    ]).set(allFailed), monocle.Lens.fromPath([
        'currentUploadStatus',
        'loadedSize'
    ]).set(status.loadedSize || 0))(state);
}
exports.methods['/FILEUPLOAD_FILE_REQUEST'] = handleFile;
exports.methods['/FILEUPLOAD_FILE_SUCCESS'] = handleFile;
exports.methods['/FILEUPLOAD_FILE_FAILURE'] = handleFile;
exports.methods['/RESET_CURRENT_UPLOAD_STATUS'] = function (state, action) {
    return fp.function.compose(currentUploadStatusLens.set(__assign(__assign({}, initialState.currentUploadStatus), { session: action.payload })), filesLens.set([]), uploadedFilesLens.set({}))(state);
};
var create = function (prefix) {
    return function (state, action) {
        if (state === void 0) { state = __assign({}, initialState); }
        if (action.type.startsWith(prefix)) {
            var suffix = action.type.replace(prefix, '');
            var fn = exports.methods[suffix];
            if (fn) {
                return fn(state, action, suffix);
            }
        }
        return state;
    };
};
exports.create = create;
